<script setup>
import ContentCard from "@/app/components/common/ContentCard.vue";

/* eslint-disable no-undef */
defineProps({
  noBox: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <section class="section section-with-divider">
    <ContentCard
      heading="Mein therapeutisches Angebot"
      subheading="Ich behandle in meiner Praxis unter anderem"
      :no-box="noBox"
    >
      <template v-slot:description>
        <p>
          Als Heilpraktikerin für Psychotherapie biete ich Ihnen professionelle
          Unterstützung bei verschiedenen psychischen Belastungen und
          Lebenskrisen. In einem geschützten Rahmen arbeiten wir gemeinsam an
          Ihren individuellen Themen.
        </p>
      </template>
      <ul class="therapy-list">
        <li>Angststörungen und Phobien</li>
        <li>Depressive Erkrankungen</li>
        <li>Anpassungsstörungen</li>
        <li>Traumafolgestörungen</li>
        <li>Burnout und Erschöpfungszustände</li>
        <li>Psychosomatische Beschwerden und Schmerzstörungen</li>
        <li>Paare in herausfordernden Situationen</li>
      </ul>
    </ContentCard>

    <ContentCard heading="Meine Methoden" :no-box="noBox">
      <template v-slot:description>
        <p>
          In meiner Arbeit kombiniere ich verschiedene therapeutische Verfahren,
          die ich individuell und fallbezogen einsetze. Dazu gehören:
        </p>
      </template>
      <ul class="therapy-list">
        <li>EMDR</li>
        <li>Traumatherapie</li>
        <li>Systemische Therapie</li>
        <li>Hypnotherapie</li>
        <li>Körperorientierte Verfahren</li>
        <li>Ego-State-Therapie</li>
        <li>Schematherapeutische Elemente</li>
        <li>Integrierte lösungsorientierte Psychotherapie (ILP)</li>
        <li>Provokative Systemarbeit</li>
        <li>Auflösen negativer Glaubenssätze</li>
        <li>Tiergestützte Interventionen</li>
        <li>Mediation und Konfliktklärung</li>
      </ul>
      <div class="closing-text">
        <p>
          Gerne kläre ich in einem telefonischen Erstgespräch den Ablauf und das
          therapeutische Vorgehen mit Ihnen.
        </p>
        <p>
          Einige private Krankenkassen, Zusatzversicherungen und Beihilfestellen
          erstatten die Kosten nach der Gebührenordnung für Heilpraktiker. Gerne
          berate ich Sie dazu persönlich.
        </p>
      </div>
    </ContentCard>
  </section>
</template>

<style scoped>
/* Extends .styled-list from Global.css with arrow marker */
.therapy-list li::before {
  content: "→";
}

.closing-text {
  margin-top: var(--spacing-md);
  padding-top: var(--spacing-md);
}
</style>
